import { ReduceMapResolver } from './types';

export class ReduceMap<T extends object> {
  constructor(protected items: T[]) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  resolveBy<R>(resolverFn: ReduceMapResolver<T, R>): Record<any, R>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  resolveBy<K extends keyof T>(key: K): Record<any, T>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  resolveBy<K extends keyof T>(keyOrResolver: K | ReduceMapResolver<T>): Record<any, T> {
    return this.items.reduce<Record<K, T>>(
      (acc, item) => {
        /* eslint-disable @typescript-eslint/no-explicit-any */
        const result =
          typeof keyOrResolver === 'function'
            ? keyOrResolver(item)
            : { [item[keyOrResolver as any]]: item };
        /* eslint-enable @typescript-eslint/no-explicit-any */

        return {
          ...result,
          ...acc,
        };
      },
      {} as Record<K, T>,
    );
  }
}
